export const DEFAULT_ELEMENT_NAME = "Untitled";
